import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';
import { transformToSelectOptions } from '~/utils/common';

import { API_ENDPOINT } from '~/constants';

import { deliveryAgencyKeys } from './keys';

import type {
  TypeDeliveryAgencyOutboundUnitSearchBoxOptions,
  TypeGetOutboundsSearchConditionsResponse,
} from '~/types/delivery-agency.types';

/**
 * [합포 단위 관리] 검색 필터 코드 조회 API
 */
export const fetchOutboundsSearchConditions = async (): Promise<TypeGetOutboundsSearchConditionsResponse['data']> => {
  const { data } = await axiosInstance.get<TypeGetOutboundsSearchConditionsResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_OUTBOUNDS_SEARCH_CONDITIONS
  );
  return data.data;
};

/**
 * [합포 단위 관리] 검색 필터 코드 조회 Query Hook
 */
export const useGetOutboundsSearchConditionsQuery = (options?: { enabled?: boolean; silent?: boolean }) => {
  return useQuery({
    queryKey: deliveryAgencyKeys.outboundsSearchConditions(),
    queryFn: fetchOutboundsSearchConditions,
    staleTime: 1000 * 60 * 30,
    enabled: options?.enabled ?? true,
    meta: { silent: options?.silent },
    select: (data): TypeDeliveryAgencyOutboundUnitSearchBoxOptions => ({
      searchKeywordTypes: transformToSelectOptions(data.searchKeywordTypes, 'code', 'description'),
      deliveryTypes: transformToSelectOptions(data.deliveryTypes, 'code', 'description'),
      courierCodes: transformToSelectOptions(data.courierCodes, 'code', 'description'),
    }),
  });
};
